<template>
  <Slider :items="items" :config="config">
    <template v-slot:body="{ item, index }">
      <Slide
        :key="index"
        :overlay="overlay"
        :paths="{
          xlarge: item.xLargeFileUrl,
          large: item.largeFileUrl,
          medium: item.mediumFileUrl,
          small: item.smallFileUrl,
        }"
        class="slide bg-cover bg-no-repeat relative overflow-hidden bg-center pt-24 md:pt-32 lg:pt-72 xl:pt-96"
      >
        <div class="max-w-screen-xl caption relative mx-auto w-full z-10">
          <div
              class="p-4 md:py-8 md:px-6 xl:p-8 xl:mx-8 lg:border-l-8 lg:border-secondary bg-gray-800 bg-opacity-75"
              v-html="item.body"
          ></div>
        </div>
      </Slide>
    </template>
    <template v-slot:navigation v-if="items.length > 1">
      <slot name="navigation">
        <div class="swiper-pagination absolute hidden lg:inline-block"></div>
      </slot>
    </template>
  </Slider>
</template>
<script>
import Slider from '../Slider';
import Slide from './Slide';
export default {
  name: 'SlideShow',
  components: { Slider, Slide },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
    overlay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
